import React, { useState } from "react";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Form, Field, FormElement } from "@progress/kendo-react-form";
import { Input, Checkbox } from "@progress/kendo-react-inputs";
import { Label } from "@progress/kendo-react-labels";
import { Button } from "@progress/kendo-react-buttons";
import SubmitButton from "components/common/SubmitButton";

const validateForm = (values) => {
  const errors = {};
  if (!values.value?.trim()) errors.value = "Name is required";
  return errors;
};

const EditClientDocumentType = (props) => {
  const ADD_NEW = props.type === "addNew";
  const [submitAttempted, setSubmitAttempted] = useState(false);

  return (
    <Dialog
      title={ADD_NEW ? "Add Document Type" : `Edit ${props?.item?.value}`}
      onClose={props.cancelEdit}
      width={500}
    >
      <>
        <Form
          onSubmit={props.onSubmit}
          initialValues={{ active: true, ...props.item }}
          validator={validateForm}
          render={(formRenderProps) => (
            <>
              <FormElement style={{ maxWidth: 1200 }}>
                <fieldset className="p-3 ps-4">
                  <div className="mb-3">
                    <Label className="label mt-1 mb-2 w-100">Name&nbsp;</Label>
                    <Field
                      name={"value"}
                      component={Input}
                      placeholder="Enter name"
                    />
                    {submitAttempted && formRenderProps.errors?.value && (
                      <div className="fs-sm my-1 text-danger">
                        <i>{formRenderProps.errors.value}</i>
                      </div>
                    )}
                  </div>
                  <Field
                    name={"active"}
                    component={Checkbox}
                    label={"Active"}
                  />
                </fieldset>
              </FormElement>

              <div className="dialog-footer">
                <Button
                  className="common-btn bgBtnSecondary me-2"
                  onClick={props.cancelEdit}
                >
                  Cancel
                </Button>
                <SubmitButton
                  className="common-btn me-3"
                  onClick={() => {
                    setSubmitAttempted(true);
                    formRenderProps.onSubmit();
                  }}
                  disabled={!formRenderProps.allowSubmit}
                  isLoading={props.isSubmitting}
                >
                  {ADD_NEW ? "Save" : "Update"}
                </SubmitButton>
              </div>
            </>
          )}
        />
      </>
    </Dialog>
  );
};

export default EditClientDocumentType;
